export const GET_TESTIMONIALS_REQUEST = "GET_TESTIMONIALS_REQUEST";
export const GET_TESTIMONIALS_SUCCESS = "GET_TESTIMONIALS_SUCCESS";
export const GET_TESTIMONIALS_FAIL = "GET_TESTIMONIALS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
